import React, { memo } from 'react';
import { Button } from '@mui/material';

import { useHandleModal } from './hooks';
import SearchForm from './search.form';
import { Dialog } from 'components/dialog';

export type SearchFieldProps = {
    searchJson?: object;
    label: string;
    search: any;
    setSearch: any;
    setPage: any;
    children?: React.ReactNode;
    layout?: 'inline' | 'side-by-side';
    isLoading?: boolean;
};

interface ChildProps {
    onClose: () => void;
    search: any;
    setSearch: (search: any) => void;
}

const SearchField = memo(
    ({
        children,
        label,
        searchJson,
        search,
        setSearch,
        setPage,
        layout,
        isLoading,
    }: SearchFieldProps) => {
        // hook
        const { openSearch, onOpenSearch, onCloseSearch } =
            useHandleModal(setPage);

        return (
            <div>
                {/* search button */}
                <Button
                    disabled={isLoading}
                    variant="outlined"
                    startIcon={<i className="fa-light fa-magnifying-glass" />}
                    onClick={() => {
                        onOpenSearch();
                    }}
                    sx={(theme) => ({
                        ...(theme.palette.mode === 'dark' && {
                            color: '#fff',
                            borderColor: 'rgba(255,255,255,.22)',
                            '& .MuiButton-startIcon': {
                                color: 'inherit',
                            },
                            '&:hover': {
                                borderColor: 'rgba(255,255,255,.38)',
                                backgroundColor: 'rgba(255,255,255,.04)',
                            },
                        }),
                    })}
                >
                    جستجو
                </Button>
                <Dialog
                    type="search"
                    icon={<i className="fa-light fa-magnifying-glass" />}
                    onClose={onCloseSearch}
                    open={openSearch}
                    label={`جستجو ${label}`}
                    {...(layout === 'side-by-side' ? { maxWidth: 'sm' } : {})}>
                    {searchJson ? (
                        <SearchForm
                            key={openSearch ? 'open' : 'closed'}
                            searchJson={searchJson}
                            onClose={onCloseSearch}
                            search={search}
                            setSearch={setSearch}
                            layout={layout}
                        />
                    ) : (
                        React.Children.map(children, (child) => {
                            if (React.isValidElement(child)) {
                                return React.cloneElement(child, {
                                    onClose: onCloseSearch,
                                    search: search,
                                    setSearch: setSearch,
                                } as ChildProps);
                            }
                        })
                    )}
                </Dialog>
            </div>
        );
    },
);

export default SearchField;
